module.exports = __webpack_public_path__ + "img/rule_title.17cc7927.png";